module.exports = __webpack_public_path__ + "assets/b84.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b84.png
// module id = 676
// module chunks = 0